import { axiosInstance } from "@/config/axiosInstance";

//  ****** GET NOTIFICATIONS FOR EMPLOYEE ******
export const fetchCurrentEmployeeNotifications = (data: {
  page?: number;
  employeeKey: string;
}) =>
  axiosInstance
    .post<{
      success: boolean;
      remaining: number;
      notifications: {
        article: string;
        createdAt: string;
        isSeen: boolean;
        notificationTitle: string;
        _id: string;
      }[];
    }>(
      `/notification/all/employee`,
      {
        page: data?.page,
      },
      {
        headers: {
          authorization: `Bearer ${data?.employeeKey}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);

//  ****** GET NOTIFICATIONS Count FOR EMPLOYEE ******
export const fetchUnseenNotificationCountForEmployee = (data: {
  employeeKey: string;
}) =>
  axiosInstance
    .get<{
      success: boolean;
      notSeen: number;
    }>(`/notification/seen/employee`, {
      headers: {
        authorization: `Bearer ${data?.employeeKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** Mark Read notifications ******
export const markNotificationsAsReadForEmployee =
  (employeeKey: string) => (ids: string[]) =>
    axiosInstance
      .post(
        `/notification/make/seen/employee`,
        {
          ids,
        },
        {
          headers: {
            authorization: `Bearer ${employeeKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);
